import { render, staticRenderFns } from "./FileLinkRenderer.vue?vue&type=template&id=356c536c&"
import script from "./FileLinkRenderer.vue?vue&type=script&lang=js&"
export * from "./FileLinkRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports